import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Rocket } from "lucide-react";
import { trackEvent } from "@/lib/retention";
import XPlacement from "@/components/public/XPlacement";
import RoleContinue from "@/components/public/RoleContinue";

/**
 * Phase 11.5 — Customer-first hero. Single source of truth, no A/B/C
 * experiment. Copy is the user-mandated:
 *    THE LIFTED LIFESTYLE STARTS HERE
 *    Shop Lifted Gear. Explore Lifted Accessories.
 *    Discover new opportunities. Become part of a growing community.
 */
export default function HomeHero() {
  return (
    <section data-testid="home-hero" className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-12 lg:pt-20 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 fade-up" data-testid="home-hero-copy">
          <div className="eyebrow flex items-center gap-2"><Rocket className="h-3 w-3" /> LiftedAtTheMoment™️🚀</div>
          <h1 className="font-anton text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.95] mt-4 break-words">
            One brand.<br /><span className="text-lifted-green">One ecosystem.</span><br />Endless lift.
          </h1>
          <p className="text-lifted-dim text-base sm:text-lg mt-6 max-w-xl">
            Lifted gear, accessories, and same-day Lifted Supplies — backed by a community-driven affiliate
            network and a growing delivery operation. Shop the brand. Power the network. Grow with us.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/shop"
              className="btn-lifted"
              data-testid="hero-cta-shop"
              onClick={() => trackEvent("hero_cta_click", { cta: "shop" })}
            >
              Shop Now <ArrowRight className="h-3 w-3 ml-1" />
            </Link>
            <Link
              to="/ecosystem"
              className="btn-ghost"
              data-testid="hero-cta-ecosystem"
              onClick={() => trackEvent("hero_cta_click", { cta: "ecosystem" })}
            >
              Explore the ecosystem
            </Link>
          </div>
          <div className="mt-6"><RoleContinue /></div>
        </div>
        <div className="lg:col-span-5 flex justify-center fade-up delay-1">
          <XPlacement zone="home-hero" variant="hero" alt="LiftedAtTheMoment" />
        </div>
      </div>
    </section>
  );
}
